import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

const inputCls = "w-full bg-transparent border border-vv-black/20 focus:border-vv-black outline-none px-3 py-2.5 text-sm placeholder:text-vv-stone transition-colors";

export default function StaffSetup() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/staff-setup", { token, password });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="staff-setup-page" className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md border border-vv-black/10 p-8 md:p-10">
        <p className="vv-overline text-vv-muted mb-3">Velour &amp; Vane Studio</p>
        <h1 className="font-display text-3xl tracking-tight mb-6">{done ? "You're all set" : "Set your password"}</h1>
        {done ? (
          <div data-testid="staff-setup-success">
            <p className="text-sm text-vv-muted mb-8">Your staff account is active. Sign in with your email and new password to open the admin studio.</p>
            <Link to="/auth" data-testid="staff-setup-login-link" className="vv-btn-dark w-full inline-block text-center">Go to Sign In</Link>
          </div>
        ) : !token ? (
          <p data-testid="staff-setup-invalid" className="text-sm text-vv-muted">This invite link is missing its token. Please use the exact link from your invite email.</p>
        ) : (
          <form data-testid="staff-setup-form" onSubmit={submit} className="space-y-4">
            <p className="text-sm text-vv-muted">Welcome to the team. Choose a password to activate your staff account.</p>
            <input data-testid="staff-setup-password" required type="password" minLength={6} value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="New password (min 6 characters)" className={inputCls} />
            <input data-testid="staff-setup-confirm" required type="password" minLength={6} value={confirm}
              onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm password" className={inputCls} />
            <button data-testid="staff-setup-submit" type="submit" disabled={busy} className="vv-btn-dark w-full">
              {busy ? "Activating…" : "Activate Account"}
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
